export enum ResponseState {
    Pending,
    Success,
    Error,
}
